import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-85" data-mp="9ktd9lkk7ywp">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-86" data-mp="9lbkfd8rfxje">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-gold" data-id="element-87" data-mp="4mrt0xbedtjn">
          🏆 SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-white sm:text-[30px]" data-id="element-88" data-mp="sai4p4p7cx7b">
          Elite Grades. Zero Burnout. The Only System You'll Ever Need.
        </p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-gold-shine pb-1 pt-1 font-display text-[25px] font-extrabold tracking-tight sm:text-5xl" data-id="element-89" data-mp="3d1sa6w93nhsl">
          THE ACADEMIC EDGE
        </motion.h1>
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-silver-deep sm:text-base" data-id="element-90" data-mp="3o73qeex4209n">
          YOUR ENTIRE SEMESTER SOLVED FROM TODAY
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-xl" data-id="element-91" data-mp="3e84nze2xv0v3">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-gold/20 blur-3xl" aria-hidden="true" data-id="element-92" data-mp="35aue9x5rrjsa" />
          <img src="https://cdn.magicpatterns.com/uploads/5vZQjExYewNGerjd5kRaDd/ChatGPT_Image_10_ago_2026,_18_39_32.png" alt="The Academic Edge — 12 volumes and 5 bonuses in digital format" width={1536} height={1024} className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-contain" data-id="element-93" data-mp="2vjpzaxg3fyxg" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-white/50" data-id="element-94" data-mp="n9qid8z0cs7f">
          The #1 system to pass every subject without retaking
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-95" data-mp="1ayt68yk8jhad">
          <CTAButton href="#value" data-id="element-96" data-mp="162ubmt8bd31i">See the offer</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-white/70 sm:text-lg" data-id="element-97" data-mp="112g4reig7z52">
            Everything you need to study with a real method, retain information deeply and perform
            without mental blocks. No improvising. No wasting another year of your degree.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-silver sm:text-xl" data-id="element-98" data-mp="3hrd7mqiwb1xs">
            Study Method · Retention · Organization · Anxiety Management · Performance
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-99" data-mp="268g468c4awp9">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-100" data-mp="2b2k6geafugk0">
                <Icon className="h-3.5 w-3.5 text-gold" data-id="element-101" data-mp="2ozz426auhun2" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-white/50" data-id="element-102" data-mp="2tyaf2kcvmb6v">
            12 Volumes · 5 Bonuses · +100 pages — Everything solved.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-103" data-mp="zl0zqbxnfvgp">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-104" data-mp="3vhp5ny5g6eqi">
              <Icon className="h-4 w-4 text-gold" data-id="element-105" data-mp="3vjrsk9bazrr0" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-gold/50 bg-gold/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-gold-soft" data-id="element-106" data-mp="e77grka8v5gf">
          🔥 Launch offer ends soon · Price goes up to $50
        </motion.div>
      </div>
    </header>;
}